import { Button, Spinner } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getPdf } from 'services/pdf.service';
import { getPdfByName, setPdf } from 'reducers/pdf.slice';

import { useAppDispatch, useAppSelector } from 'hooks/hooks';

import DownloadDtoModel from 'models/DownloadDtoModel';

interface Props {
    model: DownloadDtoModel;
    fontSize?: string;
}

const DownloadPdf = ({ model, fontSize }: Props) => {

    const dispatch = useAppDispatch();
    const loadingIds = useAppSelector(x => x.pdfs.loadingIds);

    const selectedPdfs = useAppSelector(x => getPdfByName(x.pdfs.pdfs, model.fileName));

    const onFileNameClick = () => {

        if (!loadingIds.some(l => l === model.fileId)) {
            if ((selectedPdfs.length === 0 ||
                selectedPdfs.find(s => !s.file && s.fileId === model.fileId))) {
                dispatch(getPdf({
                    fileId: model.fileId,
                    fileName: model.fileName || "",
                    recordType: model.recordType
                }));
            } else
                dispatch(setPdf(selectedPdfs));
        }
    };

    return (
        <>
{model.fileId.indexOf(" ADV") > -1 ?
                model.fileName
                :
                <Button color="link" data-tooltip="Click Twice to View Document" aria-label={`Download ${model.fileName}`} className={`button text-decoration-none p-0 m-0 lh-1 text-nowrap ${fontSize}`} onClick={onFileNameClick}>
                    <div className="button-wrapper">
                        <div className="text">{model.fileName}</div>
                        <span className="icon">
                            {loadingIds &&
                                loadingIds.some(l => l === model.fileId) ?
                                <Spinner size='sm'>
                                    Loading...
                                </Spinner>
                                :
                                selectedPdfs.length > 0 ?
                                    selectedPdfs.find(s => s.file === "") ?
                                        <FontAwesomeIcon icon='triangle-exclamation' />
                                        :
                                        <FontAwesomeIcon icon='magnifying-glass' />
                                    :
                                    <FontAwesomeIcon icon='download' />
                            }
                        </span>
                    </div>
                </Button>
            }
</>
    );
}

export default DownloadPdf;